import request from '@/utils/request'


export function getListByGroupId(params) {
    return request({
        url: 'api/carInspectionCoupon/getListByGroupId',
        method: 'get',
        params
    })
}

export function receiveCoupon(params) {
    return request({
        url: 'api/carInspectionCoupon/receiveCoupon',
        method: 'get',
        params
    })
}

export function getUserCouponCount(params) {
    return request({
        url: 'api/carInspectionCoupon/getUserCouponCount',
        method: 'get',
        params
    })
}

export function getCouponSends(params) {
    return request({
        url: 'api/carInspectionCoupon/getCouponSends',
        method: 'get',
        params
    })
}

export function getCouponNoUses(params) {
    return request({
        url: 'api/carInspectionCoupon/getCouponNoUses',
        method: 'get',
        params
    })
}

export default {getListByGroupId, receiveCoupon, getUserCouponCount, getCouponSends, getCouponNoUses}
